import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Check, ArrowUpRight } from "lucide-react";
import api from "@/lib/api";

export default function Pricing() {
    const [plans, setPlans] = useState([]);
    useEffect(() => { api.get("/plans").then((r) => setPlans(r.data.plans)); }, []);
    return (
        <main data-testid="pricing-page" className="pt-[72px]">
            <section className="bg-[#0B1930] text-white pt-24 pb-24 relative overflow-hidden grain">
                <div className="hero-glow top-[-30%] right-[-10%]" style={{ background: "#E8B923" }} />
                <div className="max-w-[1400px] mx-auto px-6 lg:px-10 relative">
                    <div className="eyebrow">Pricing</div>
                    <h1 className="headline text-5xl md:text-6xl lg:text-7xl mt-6 max-w-3xl">
                        Flexible plans. <em className="not-italic text-[#E8B923]">Enterprise scale.</em>
                    </h1>
                    <p className="text-white/70 text-lg mt-6 max-w-2xl">
                        Start free. Scale to a fully-managed enterprise deployment with SSO, private cloud and dedicated support.
                    </p>
                </div>
            </section>
            <section className="py-20 max-w-[1400px] mx-auto px-6 lg:px-10">
                <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
                    {plans.map((p, i) => (
                        <div key={p.key} data-testid={`pricing-plan-${p.key}`} className={`rounded-2xl p-8 border ${p.key === "business" ? "bg-navy text-white border-navy" : "bg-white border-slate-200"}`}>
                            <div className={`eyebrow ${p.key === "business" ? "text-[#E8B923]" : "eyebrow--slate"}`}>{p.key}</div>
                            <h3 className="font-serif text-2xl mt-3">{p.name}</h3>
                            <div className={`font-mono text-xs mt-2 ${p.key === "business" ? "text-white/60" : "text-slate-500"}`}>{p.price_note}</div>
                            <ul className="mt-6 space-y-3">
                                {(p.features || []).map((f) => (
                                    <li key={f} className="flex items-start gap-2 text-sm">
                                        <Check className={`w-4 h-4 mt-0.5 flex-shrink-0 ${p.key === "business" ? "text-[#E8B923]" : "text-navy"}`} />
                                        <span className={p.key === "business" ? "text-white/80" : "text-slate-600"}>{f}</span>
                                    </li>
                                ))}
                            </ul>
                            <Link to="/request-demo" className={`mt-8 w-full justify-center inline-flex items-center gap-2 rounded-full py-3 px-5 text-sm font-medium transition ${p.key === "business" ? "bg-[#E8B923] text-navy hover:brightness-110" : "bg-navy text-white hover:bg-[#2563EB]"}`}>
                                {p.cta} <ArrowUpRight className="w-4 h-4" />
                            </Link>
                        </div>
                    ))}
                </div>
            </section>
        </main>
    );
}
